notifyClose = function() {
    document.querySelector('.gm-container-fluid.gm-notify-bar').remove();
}

const swiperHero = new Swiper('#hero-slider', {
    direction: 'horizontal',
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    effect: 'fade',
    autoplay: {
      delay: 15000,
    },
});

const swiperProducts = new Swiper('#products-slider', {
    direction: 'horizontal',
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    slidesPerView: 4,
    slidesPerGroup: 4,
    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView: 1.3,
            spaceBetween: 20,
            slidesPerGroup: 1,
            centeredSlides: false,
            centeredSlidesBounds: true,
            loop: true
        },
        // when window width is >= 390px
        390: {
            slidesPerView: 1.4,
            spaceBetween: 20,
            slidesPerGroup: 1,
            centeredSlides: false,
            centeredSlidesBounds: true,
            loop: true
        },
        // when window width is >= 480px
        480: {
            slidesPerView: 2,
            spaceBetween: 20,
            slidesPerGroup: 1,
            centeredSlides: false,
            centeredSlidesBounds: true,
            loop: true
        },
        // when window width is >= 640px
        640: {
            slidesPerView: 2.5,
            spaceBetween: 10,
            centeredSlides: false,
            centeredSlidesBounds: true,
            loop: true
        },
        // when window width is >= 768px
        768: {
            slidesPerView: 3,
            spaceBetween: 20,
            centeredSlides: false,
            centeredSlidesBounds: true,
            loop: true,
            allowTouchMove: true
        },
        // when window width is >= 991px
        991: {
            slidesPerView: 3,
            spaceBetween: 20,
            centeredSlides: false,
            centeredSlidesBounds: true,
            loop: true,
            slidesPerGroup: 4,
            allowTouchMove: false
        },
        // when window width is >= 1200px
        1200: {
            slidesPerView: 4,
            spaceBetween: 20,
            centeredSlides: false,
            centeredSlidesBounds: true,
            loop: true,
            slidesPerGroup: 4,
            allowTouchMove: false
        }
    }
});

toggleMainMenu = function() {
    let menu = document.querySelector('.main-menu');
    if ( menu.classList.contains('active') ) {
        menu.classList.remove('active');
    }
    else {
        menu.classList.add('active');
    }
}
